import {
  useUpdateAccessControlTableTitleMutation,
  useUpdateTableTitleMutation,
} from "../store/apiSlices/dealTracker";
import { Table, TableWithShare } from "../types/DealTracker";

export function useTableTitleUpdater(table: Table | TableWithShare) {
  const [updateTableTitle] = useUpdateTableTitleMutation();
  const [updateSharedTableTitle] = useUpdateAccessControlTableTitleMutation();

  return async (title: string) => {
    if ("shared" in table && table.shared) {
      return updateSharedTableTitle({
        id: table.id,
        title,
        parent_id: table.uid,
      }).unwrap();
    }

    return updateTableTitle({
      id: table.id,
      title,
    }).unwrap();
  };
}
